import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const LogoutIcon = (props: IconProps) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 12C11.7167 12 11.4793 11.904 11.288 11.712C11.0967 11.52 11.0007 11.2827 11 11V3C11 2.71667 11.096 2.47934 11.288 2.288C11.48 2.09667 11.7173 2.00067 12 2C12.2827 1.99934 12.5203 2.09534 12.713 2.288C12.9057 2.48067 13.0013 2.718 13 3V11C13 11.2833 12.904 11.521 12.712 11.713C12.52 11.905 12.2827 12.0007 12 12ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.39667 19.8133 6.44667 19.1717 5.638 18.363C4.82933 17.5543 4.18767 16.6043 3.713 15.513C3.23833 14.4217 3.00067 13.2507 3 12C3 10.9833 3.16667 9.99567 3.5 9.037C3.83333 8.07834 4.31667 7.19934 4.95 6.4C5.13333 6.16667 5.36667 6.05434 5.65 6.063C5.93333 6.07167 6.18333 6.184 6.4 6.4C6.58333 6.58334 6.66667 6.80834 6.65 7.075C6.63333 7.34167 6.54167 7.59167 6.375 7.825C5.925 8.425 5.58333 9.08334 5.35 9.8C5.11667 10.5167 5 11.25 5 12C5 13.95 5.67933 15.6043 7.038 16.963C8.39667 18.3217 10.0507 19.0007 12 19C13.9493 18.9993 15.6037 18.3203 16.963 16.963C18.3223 15.6057 19.0013 13.9513 19 12C19 11.2333 18.8877 10.4873 18.663 9.762C18.4383 9.03667 18.084 8.37434 17.6 7.775C17.4333 7.55834 17.3417 7.321 17.325 7.063C17.3083 6.805 17.3917 6.584 17.575 6.4C17.775 6.2 18.0167 6.096 18.3 6.088C18.5833 6.08 18.8167 6.184 19 6.4C19.65 7.2 20.146 8.075 20.488 9.025C20.83 9.975 21.0007 10.9667 21 12C21 13.25 20.7627 14.421 20.288 15.513C19.8133 16.605 19.1717 17.555 18.363 18.363C17.5543 19.171 16.6043 19.8127 15.513 20.288C14.4217 20.7633 13.2507 21.0007 12 21Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LogoutIcon;

